import { X } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { cn } from "@/lib/utils";

export default function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div
      aria-live="assertive"
      aria-atomic="true"
      className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-end gap-2 p-4 sm:p-6"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            "pointer-events-auto w-full max-w-sm rounded-lg border border-border bg-card text-card-foreground shadow-lg",
            t.open === false && "opacity-0 scale-95",
            "transition-all"
          )}
          role="status"
        >
          <div className="flex items-start gap-3 p-4">
            <div className="flex-1">
              {t.title ? (
                <div className="text-sm font-semibold">{t.title}</div>
              ) : null}
              {t.description ? (
                <div className="mt-1 text-sm text-muted-foreground">{t.description}</div>
              ) : null}
              {t.action ? <div className="mt-3">{t.action}</div> : null}
            </div>
            <button
              aria-label="Close"
              onClick={() => dismiss(t.id)}
              className="rounded-md p-1 text-muted-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
